import { createAsyncThunk } from '@reduxjs/toolkit';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../../../firebaseConfig';

// Get waitlist goal from Firestore with caching
export const getWaitlistGoal = createAsyncThunk(
  'waitlist/getGoal',
  async (_, { getState }) => {
    const state = getState().waitlist;
    const now = Date.now();
    const CACHE_DURATION = 10 * 60 * 1000; // 10 minutes

    if (state.goal && state.goalLastUpdate && (now - state.goalLastUpdate) < CACHE_DURATION) {
      return { goal: state.goal, lastUpdated: state.goalLastUpdate };
    }

    // Read from Firestore: settings/waitlist { goal: number }
    try {
      const settingsDoc = await getDoc(doc(db, 'settings', 'waitlist'));
      const goal = settingsDoc.exists() && typeof settingsDoc.data().goal === 'number'
        ? settingsDoc.data().goal
        : 20000; // default

      return { goal, lastUpdated: now };
    } catch (e) {
      // On error, return existing state or default
      return { goal: state.goal || 20000, lastUpdated: now };
    }
  }
);
